export default __webpack_public_path__ + "static/media/undraw_shopping_app.e2633bb4.svg";